/**
 * Messages liés aux suggestions de publications
 */

module.exports = {

    status: {
        draft: 'Draft',
        enabled: 'Enabled',
        disabled: 'Disabled'
    },

    thematics: {
        product: 'Product/service',
        actuality: 'Actuality',
        event: 'Event',
        recruitment: 'Recruitement',
        brand: 'Brand'
    }

};
